import { useMemo } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { backend } from '../axios/backend';
import ProductForm from '../components/ProductForm';
import Breadcrumbs from '../components/ui/Breadcrumbs';
import { useAppContext } from '../context/AppContext';
import { usePersons } from '../hooks/usePersons';
import { parseErrorMessage } from '../utils/error-message';

const AddIdeaForPersonPage = () => {
  const { alertSuccess, alertError } = useAppContext();
  const navigate = useNavigate();
  const params = useParams();

  const query = usePersons({ refetchOnMount: false, refetchOnWindowFocus: false });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const person = useMemo(() => query.data?.find((p) => p.id === params.personId), [query.data]);

  const queryClient = useQueryClient();
  const mutation = useMutation(
    async (values: {
      name: string;
      price?: number;
      comment?: string;
      url?: string;
      tags?: string[];
      imageUrl?: string;
    }) => {
      await backend.post(`/person/${params.personId}/idea`, values);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['ideas', params.personId]);
        alertSuccess('Idee hinzugefügt.');
        navigate(`/ideas/${params.personId}`);
      },
      onError: (e) => {
        alertError(parseErrorMessage(e));
      },
    },
  );

  return (
    <div style={{ margin: '2rem' }} className="space-y-4">
      <Breadcrumbs
        crumbs={[
          { text: 'Ideen', route: '/ideas' },
          { text: person?.name || 'Person', route: '/ideas/' + params.personId },
          { text: 'Idee hinzufügen', route: `/ideas/${params.personId}/add` },
        ]}
      />
      <h1 className="text-white text-xl">
        <b>Idee hinzufügen</b>
      </h1>
      <ProductForm onSubmit={mutation.mutate} isLoading={mutation.isLoading} submitText="Idee hinzufügen" type="idea" />
    </div>
  );
};

export default AddIdeaForPersonPage;
